import FormItem from "@components/formItem";
import { BANK_LIST } from "@enums";
import { PaymentContentWrapper } from "@pages/profile-v2/pages/withdraw/baseItems";
import React from "react";
import MaskInput from "react-maskinput";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, MaskedInput, StakeInput } from "../baseItems";
import Base from "./base";

export default class BankTransferCepbank extends Base {
	onSelectBankLocal(e) {
		this.setState(
			{
				selectedBank: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { selectedCurrency, selectedBank } = this.state;
		let bankOptions = [
			{ value: 0, label: translate("PLEASE_SELECT") },
			{ value: "papara", label: translate("PAPARA") },
		];
		BANK_LIST.map((item) => {
			let newOpt = { value: item.id, label: item.bankName };
			bankOptions.push(newOpt);
		});
		let bank = selectedBank ? bankOptions.find((o) => o.value === selectedBank).value : 0;
		return (
			<Content>
				<ContentTitle data-testid="step-deposit-amount-title">{translate("Payment_Stake")}</ContentTitle>
				<PaymentContentWrapper>
					<div>{this.getCurrencyField(translate)}</div>
				</PaymentContentWrapper>
				<FormItem onRegister={() => this.registerField({ name: "selectedBank" })}>
					<Box>
						<BoxTitle>{translate("BANK_NAME")}</BoxTitle>
						<PaymentSelect
							data-testid="step-deposit-amount-bank-picker"
							options={bankOptions}
							value={bank}
							handleSelect={this.onSelectBankLocal.bind(this)}
						/>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "ssn" })}>
					<Box>
						<BoxTitle>{translate("NATIONAL_ID_NO")}</BoxTitle>
						<MaskedInput>
							<MaskInput
								data-testid="input-deposit-national-id"
								alwaysShowMask={window.IS_MARS ? true : false}
								maskChar="_"
								mask="0 0 0 0 0 0 0 0 0 0 0"
								onChange={this.onEnterValue.bind(this, "ssn")}
							/>
						</MaskedInput>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "fullName" })}>
					<Box>
						<BoxTitle>{translate("SENDER_FULLNAME")}</BoxTitle>
						<StakeInput
							data-testid="input-deposit-sender-fullname"
							autoFocus={true}
							placeholder="...................."
							onChange={this.onEnterValue.bind(this, "fullName")}
						/>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "senderMobile" })}>
					<Box>
						<BoxTitle>{translate("SENDER_MOBILE")}</BoxTitle>
						<MaskedInput>
							<MaskInput
								data-testid="input-deposit-sender-mobile"
								alwaysShowMask={window.IS_MARS ? true : false}
								maskChar="."
								mask="+9\0 (000) 000 00 00"
								onChange={this.onEnterValue.bind(this, "senderMobile")}
							/>
						</MaskedInput>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "recipientMobile" })}>
					<Box>
						<BoxTitle>{translate("RECIPIENT_MOBILE")}</BoxTitle>
						<MaskedInput>
							<MaskInput
								data-testid="input-deposit-recipient-mobile"
								alwaysShowMask={window.IS_MARS ? true : false}
								maskChar="."
								mask="+9\0 (000) 000 00 00"
								onChange={this.onEnterValue.bind(this, "recipientMobile")}
							/>
						</MaskedInput>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "branchCode" })}>
					<Box>
						<BoxTitle>{translate("REFERENCE")}</BoxTitle>
						<StakeInput
							data-testid="input-deposit-reference"
							autoFocus={true}
							placeholder="...................."
							onChange={this.onEnterValue.bind(this, "branchCode")}
						/>
					</Box>
				</FormItem>
				{selectedCurrency &&
					selectedCurrency != translate("PLEASE_SELECT") &&
					this.getStakeField(translate("AMOUNT"), false)}
				<div>{this.renderMinMax()}</div>
				<FormItem onRegister={() => this.registerField({ name: "expirationDate" })}>
					<Box small={true}>
						<BoxTitle>{translate("EXPIRY_DAY")}</BoxTitle>
						<MaskedInput>
							<MaskInput
								data-testid="input-deposit-expiry-date"
								alwaysShowMask={window.IS_MARS ? true : false}
								maskChar="."
								mask="00/00/0000"
								onChange={this.onEnterValue.bind(this, "expirationDate")}
							/>
						</MaskedInput>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "recipientSSN" })}>
					<Box>
						<BoxTitle>{translate("RECIPIENT_NATIONAL_ID_NO")}</BoxTitle>
						<MaskedInput>
							<MaskInput
								data-testid="input-deposit-recipient-national-id"
								alwaysShowMask={window.IS_MARS ? true : false}
								maskChar="_"
								mask="0 0 0 0 0 0 0 0 0 0 0"
								onChange={this.onEnterValue.bind(this, "recipientSSN")}
							/>
						</MaskedInput>
					</Box>
				</FormItem>
				<FormItem onRegister={() => this.registerField({ name: "recipientBirthDate" })}>
					<Box>
						<BoxTitle>{translate("RECIPIENT_BIRTHDATE")}</BoxTitle>
						<MaskedInput>
							<MaskInput
								data-testid="input-deposit-recipient-birthdate"
								alwaysShowMask={window.IS_MARS ? true : false}
								maskChar="."
								mask="00/00/0000"
								onChange={this.onEnterValue.bind(this, "recipientBirthDate")}
							/>
						</MaskedInput>
					</Box>
				</FormItem>
			</Content>
		);
	}

	makeExternalPayment(newStep) {
		const {
			stake,
			branchCode,
			selectedBank,
			fullName,
			ssn,
			selectedCurrency,
			expirationDate,
			senderMobile,
			recipientMobile,
			recipientBirthDate,
			recipientSSN,
		} = this.state;
		this.props.externalFunc.depositBankTransfer(
			{
				amount: parseInt(stake),
				language: this.getActiveLanguageCode(),
				bankName: selectedBank,
				ssn: ssn.replaceAll(" ", ""),
				fullName: fullName,
				currency: selectedCurrency,
				senderMobile: senderMobile
					.replaceAll(" ", "")
					.replaceAll("(", "")
					.replaceAll(")", "")
					.substring(3),
				recipientMobile: recipientMobile
					.replaceAll(" ", "")
					.replaceAll("(", "")
					.replaceAll(")", "")
					.substring(3),
				reference: branchCode,
				idExpirationDate: expirationDate.replaceAll("/", "."),
				recipientSSN: recipientSSN.replaceAll(" ", ""),
				recipientBirthDate: recipientBirthDate.replaceAll("/", "."),
				claimsBonus: false,
			},
			(data) => {
				this.onBackToDepositPage();
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const {
			stake,
			branchCode,
			selectedBank,
			fullName,
			ssn,
			selectedCurrency,
			expirationDate,
			senderMobile,
			recipientMobile,
			recipientBirthDate,
			recipientSSN,
		} = this.state;
		this.props.externalFunc.depositBankTransfer(
			{
				amount: parseInt(stake),
				language: this.getActiveLanguageCode(),
				bankName: selectedBank,
				ssn: ssn.replaceAll(" ", ""),
				fullName: fullName,
				currency: selectedCurrency,
				senderMobile: senderMobile
					.replaceAll(" ", "")
					.replaceAll("(", "")
					.replaceAll(")", "")
					.substring(3),
				recipientMobile: recipientMobile
					.replaceAll(" ", "")
					.replaceAll("(", "")
					.replaceAll(")", "")
					.substring(3),
				reference: branchCode,
				idExpirationDate: expirationDate.replaceAll("/", "."),
				recipientSSN: recipientSSN.replaceAll(" ", ""),
				recipientBirthDate: recipientBirthDate.replaceAll("/", "."),
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.onBackToDepositPage();
			}
		);
	}
}
